<template>
    <div>
        <div class="row no-gutters vh-100">
            <!-- left col -->
            <div class="col-lg-6 d-flex justify-content-center mt-6 mt-lg-24 relative">
                <div class="absolute container -top-4 left-0 w-full flex justify-end">
                    <a href="/login?lang=it" class="font-bold mr-2 sm:mr-4">Ita</a>
                    <a href="/login?lang=en" class="font-bold sm:mr-4">Eng</a>
                </div>
                <div class="container pb-10 flex items-center">
                    <div class="max-w-sm mx-auto">
                        <div class="flex mb-5">
                            <a href="/" class="block mr-4">
                                <img class="h-10" src="/images/logo_login.png" />
                            </a>
                            <!--
                            <a href="/" class="block">
                                <img class="h-10" src="/images/fondo-sociale-europeo_logo.png" />
                            </a>
                            -->
                        </div>

                        <!-- Form -->
                        <form @submit.prevent="submit">
                            <div class="mb-5">
                                <div class="text-black font-16px">
                                    {{ $t("insert_credentials") }}
                                </div>
                                <div class="input-label-secondary font-14px">
                                    {{ $t("are_not_registered") }}
                                    <inertia-link :href="route('register')">
                                        {{ $t("register") }}
                                    </inertia-link>
                                </div>
                            </div>

                            <!-- error -->
                            <div class="mb-4">
                                <small v-if="form.errors.email" class="text-danger">{{ $t("login_ko") }}</small>
                            </div>

                            <!-- Form Group -->
                            <div class="js-form-message form-group">
                                <input type="email" class="form-control form-control-sm" name="email" id="signupSrEmail" placeholder="Email" onfocus="this.placeholder=''" onblur="this.placeholder='Email'" v-model="form.email" required data-msg="Please enter a valid email address." />
                            </div>
                            <!-- End Form Group -->

                            <!-- Form Group -->
                            <div class="js-form-message form-group">
                                <div class="input-group input-group-merge">
                                    <input
                                        type="password"
                                        class="js-toggle-password form-control form-control-sm"
                                        name="password"
                                        id="signupSrPassword"
                                        placeholder="Password"
                                        v-model="form.password"
                                        onfocus="this.placeholder=''"
                                        onblur="this.placeholder='Password'"
                                        aria-label="8+ characters required"
                                        required=""
                                        data-msg="Your password is invalid. Please try again."
                                        data-hs-toggle-password-options="{
                             'target': '#changePassTarget',
                             'defaultClass': 'tio-hidden-outlined',
                             'showClass': 'tio-visible-outlined',
                             'classChangeTarget': '#changePassIcon'
                           }"
                                    />
                                </div>
                            </div>
                            <!-- End Form Group -->

                            <button type="submit" class="btn btn-primary" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                                {{ $t("login") }}
                            </button>

                            <label class="input-label mt-5" for="signupSrPassword" tabindex="0">
                                <span class="d-flex align-items-center">
                                    <inertia-link :href="route('password.request')" class="input-label-secondary font-14px">
                                        {{ $t("forgot_password") }}
                                    </inertia-link>
                                </span>
                            </label>
                        </form>
                    </div>
                </div>
            </div>

            <!-- right col -->
            <div class="d-none d-lg-block col-lg-6 justify-content-center h-100">
                <div class="bg-from-yellow-to-white text-center h-100 flex flex-col justify-center">
                    <img src="images/lamp_img.png" class="mx-auto" width="60%" />
                    <div class="font-72px text-yellow font-lato-black font-weight-bold">
                        {{ $t("login") }}
                    </div>
                    <div class="text-black font-16px font-lato-regular">
                        {{ $t("if_you_are_registered") }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        canResetPassword: Boolean,
        status: String,
    },

    data() {
        return {
            form: this.$inertia.form({
                email: "",
                password: "",
                remember: false,
            }),
        };
    },

    methods: {
        submit() {
            this.form
                .transform((data) => ({
                    ...data,
                    remember: this.form.remember ? "on" : "",
                }))
                .post(this.route("login"), {
                    onFinish: () => this.form.reset("password"),
                });
        },
    },
};
</script>

<style scoped>
.bg-from-yellow-to-white {
    background: linear-gradient(to bottom, #f9dfab 0%, #f2b436 100%);
}

.text-yellow {
    color: #d08c00;
}

.text-black {
    color: #141414;
}
</style>
